<label *ngIf="label" [attr.for]="for" class="select-label">
  {{ label }}
  <span *ngIf="required">*</span>
</label>
